import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bcc36e5a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc36e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcc36e5a')) {
      api.createRecord('bcc36e5a', component.options)
    } else {
      api.reload('bcc36e5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bcc36e5a&scoped=true", function () {
      api.rerender('bcc36e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/priceSetting/priceMonitoring/monitoringScreen/index.vue"
export default component.exports